var req = require("!!/Users/dw/Exploros/front-end/webpack/loaders/pug-template-loader.js!/Users/dw/Exploros/front-end/components/passageDifferentiator/passageDifferentiator.jade");
module.exports = (req['default'] || req).apply(req, [])